import { useSignupState } from './useSignupState'

export const useOnboarding = () => useSignupState().onboarding ?? {}

export const useOnboardingSession = () => useOnboarding().sessionContext ?? {}

export const useOnboardingApp = () => useOnboardingSession().app ?? {}

export const useOnboardingOsType = () => useOnboardingApp().osType
